<!--
 * @Author: lixiaodi
 * @Date: 2020-03-17 11:46:40
 * @LastEditors: lixiaodi
 * @LastEditTime: 2020-06-23 18:23:54
 -->
<template>
  <div style="margin-bottom: 80px">
      <!-- 标题 -->
      <!-- <div class="resource-top">{{title}}</div> -->
      <!-- 课件展示 -->
      <el-row :gutter="20" class="resource-middle" v-if="bookList.length">
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <div class="middle-img">
              <img :src="bookList[0].VPicture" alt="" >
            </div>
          </div>
        </el-col>
        <el-col :span="16">
          <div class="grid-content bg-purple">
            <div class="middle-info" @click="onGotoTeacherInfo(bookList[0].VTeacherId)">
              <div class="info-top">
                <p class="info-top-left">{{bookList[0].VTeacherName}}</p>
                <p>{{bookList[0].VSpecializedCourses}}</p>
              </div>
              <p class="info-bottom">{{bookList[0].VContent}}</p>
            </div>
          </div>
        </el-col>
      </el-row>
      <!-- 课件列表展示 -->
      <div class="resource-bottom" v-if="bookList.length">
        <div class="list-item" v-for="(item,index) in bookList.slice(1)"  :key="item.VTeacherId" @click="onGotoTeacherInfo(item.VTeacherId)">
          <div class="item-left">
              <p class="bookIcon"><i class="iconfont iconshuben"></i></p>
              <p style="margin-left: .06rem;">{{item.VTeacherName}}</p>
          </div>
          <div>{{item.VSpecializedCourses}}</div>
          <div>{{item.createdTime}}</div>
          <!-- <div class="item-right">
              <div class="see-btn">查看</div>
              <div class="btn-middle">|</div>
              <div class="download-btn">下载</div>
          </div> -->
        </div>
      </div>
  </div>
</template>

<script>
import { jump,getUser } from '@/untils/auth'
export default {
  name: 'ResourcesList',
  data() {
      return {
          title: '最新课件',
          example: {id:1, img: require('./../../../assets/images/book.png'), title: '轨道交通基础入门', name: '小明', content: '2009年开始'},
          bookList: []
      }
  },
  created (){
    this.onNewTeacherRes();
  },
  methods: {
    // 最新教师
    onNewTeacherRes (){
      this.axios.post(window.IPConfig.IP + '/tBusTeacher/queryAttentionTeacher.do',
          {
              VSystemId: this.$store.state.user.VSystemId,
              VUserId: JSON.parse(getUser()).principal.VUserId,
              current: '0',
              size: '8'
          }
        ).then((response) => {
            if (response.status == 200) {
                if (response.data.status == 200) {
                    // 列表赋值
                    this.bookList = response.data.obj;
                }
            }
        })
    },
    // 跳转师资详情
    onGotoTeacherInfo (VTeacherId){
      this.$router.push(
          {
              path: 'teacherInfo',
              query: {
                  VTeacherId: VTeacherId
              }
          }
      )
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~@/assets/styles/varibles.styl'
/* 头部标题 */
.resource-top{
  line-height 2
  color $backgroundCOlor
  font-weight 700
}
/* 举例展示 */
.resource-middle{

}

.middle-img{
  text-align: center;
  background: #f2f3f4;
  padding: .1rem;
  height: 2rem !important;
  width: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.middle-img img{
  max-width: 100%;
  max-height: 100%;
}

.courseware-img{
  text-align: center;
  background: #f2f3f4;
  padding: .1rem;
  height: 2rem;
}
.info-top{
  display flex
  justify-content space-between
  line-height 2
  border-bottom 1px solid #f5f6f7
  margin-bottom .1rem
}
.info-top-left{
  font-weight 700
}
.info-bottom{
  line-height 1.5
  text-indent 2em
}
/* 列表展示 */
.resource-bottom{
  height: 1.8rem;
  overflow: hidden;
}
/* 资源列表 */
.list-item{
    display flex
    flex-flow row nowrap
    line-height 2
    justify-content space-between
    align-items: center;
}
.item-left{
    display flex
    flex-flow row nowrap
    align-items center
}
.item-right{
    display flex
    flex-flow row nowrap
}
.bookIcon{
    color #22c6b6
}
.see-btn{
  color: #4abb96

}
.btn-middle{
  margin 0 .1rem
}
.download-btn{
  color: #f0818b
}
</style>



// WEBPACK FOOTER //
// src/components/Education/commonView/resourcesList.vue